/* eslint-disable @typescript-eslint/no-explicit-any */
// Converte camelCase de volta para snake_case para compatibilidade com os callers existentes
export function toSnake(obj: any): any {
  if (Array.isArray(obj)) return obj.map(toSnake)
  if (obj !== null && typeof obj === "object") {
    return Object.fromEntries(
      Object.entries(obj).map(([k, v]) => [k.replace(/([A-Z])/g, "_$1").toLowerCase(), toSnake(v)])
    )
  }
  return obj
}
